<i18n locale="en">
{
  "title": "Form Title",
  "description": "Form description goes here."
}
</i18n>

<template>
  <PreviewSheet class="form-header-preview" border="primary" radius="0">
    <div class="flex-col gap-2">
      <PreviewTypographyLegacy :text="title" variant="heading2" />
      <PreviewTypographyLegacy :text="description" variant="paragraphRegular" />
    </div>
  </PreviewSheet>
</template>

<script>
import { useI18n } from 'vue-i18n'
import { mapGetters } from 'vuex'

import PreviewTypographyLegacy from '@/lib/builder/public/preview/legacy/PreviewTypographyLegacy.vue'
import PreviewSheet from '@/lib/builder/public/preview/PreviewSheet.vue'

export default {
  name: 'FormHeaderPreview',
  components: {
    PreviewSheet,
    PreviewTypographyLegacy,
  },
  props: {
    /** Override data for out of module rendering contexts */
    populatedData: { type: Object, default: undefined },
  },
  setup() {
    const { t } = useI18n()

    return { t }
  },
  computed: {
    ...mapGetters({
      currentResource: 'formBuilder/currentResource',
    }),
    activeResource() {
      const { populatedData, currentResource } = this

      return populatedData ?? currentResource
    },
    description() {
      const { activeResource } = this

      return activeResource?.description || this.t('description')
    },
    title() {
      const { activeResource } = this

      return activeResource?.title || this.t('title')
    },
  },
}
</script>

<style lang="scss" scoped>
.form-header-preview {
  padding: 0 40px 24px;
}
</style>
